import { useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from '../../contexts/ThemeContext'

const RUTAS_SIN_FAB = ['/registro', '/premium', '/metas']

export default function FAB() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { theme } = useTheme()

  if (RUTAS_SIN_FAB.includes(pathname)) return null

  return (
    <button
      onClick={() => navigate('/registro')}
      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      style={{
        position: 'fixed', bottom: 88,
        right: 'max(16px, calc(50% - 266px))',
        width: 58, height: 58, borderRadius: '50%',
        background: theme.cardGradient,
        border: 'none', color: 'white', fontSize: 28,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: `0 8px 28px ${theme.accentDeep}55`,
        cursor: 'pointer', transition: 'transform 0.2s', zIndex: 200,
      }}
    >
      +
    </button>
  )
}
